import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
const MAX_INSTALLS_BUCKET = 10000;
const getValueFactor = (value, factor) => {
  return Math.floor(value / factor) * factor;
};

/**
 * @deprecated Prefer `bucketInstalls()` or `formatInstalls()`
 */
export const getInstallsBucket = value => {
  if (value < 10) {
    return 0;
  } else if (value < 50) {
    return getValueFactor(value, 10);
  } else if (value < 100) {
    return getValueFactor(value, 50);
  } else if (value < 500) {
    return getValueFactor(value, 100);
  } else if (value < MAX_INSTALLS_BUCKET) {
    return getValueFactor(value, 500);
  }
  return MAX_INSTALLS_BUCKET;
};

/**
 * Floors to the nearest 10 for values < 100, and 100 for values >= 100.
 * Use this when you want to do the localization yourself.
 */
export function bucketInstalls(value) {
  const floorFactor = value < 100 ? 10 : 100;
  return Math.floor(value / floorFactor) * floorFactor;
}

/**
 * Buckets and localizes installs. Use this when you want to simply
 * display "12K installs", for example.
 */
export function formatInstalls(value) {
  if (value < 10) {
    return unescapedText('marketplace-ui-common.installs.fewerThanMin');
  }
  const abbreviatedValue = I18n.abbreviateNumber(bucketInstalls(value), {
    abbreviateThreshold: 1000
  });
  if (value < 1000) {
    return unescapedText('marketplace-ui-common.installs.betweenMinAndThousand', {
      value: abbreviatedValue
    });
  }
  return unescapedText('marketplace-ui-common.installs.moreThanMin', {
    value: abbreviatedValue
  });
}